import { SaleTerm } from 'constants/payments';

/** Public campaign identifiers, not secrets or recipient entitlements. Never reassign a code. */
export const EMAIL_OFFERS = {
  annual: {
    id: 'dashboard-email-annual',
    version: 1,
    code: '8b7c19e04d52',
    action: 'switch',
    percent: 30,
    duration: 'forever',
  },
  winback: {
    id: 'dashboard-email-winback',
    version: 1,
    code: 'c6e2910b7a43',
    action: 'create',
    percent: 40,
    duration: 'once',
  },
} as const;
export type EmailOfferDefinition = (typeof EMAIL_OFFERS)[keyof typeof EMAIL_OFFERS];
export const getEmailOffer = (code: unknown): EmailOfferDefinition | null =>
  typeof code === 'string'
    ? Object.values(EMAIL_OFFERS).find((offer) => offer.code === code) || null
    : null;
export const getEmailOfferById = (id: unknown) =>
  Object.values(EMAIL_OFFERS).find((offer) => offer.id === id) || null;
export const EMAIL_RETURN_TERMS = [SaleTerm.Monthly, SaleTerm.Quarterly, SaleTerm.Annual] as const;
export type EmailReturnTerm = (typeof EMAIL_RETURN_TERMS)[number];

/** A card-page cancel may restore a tab. It never supplies a quote, consent or entitlement. */
export const getEmailOfferTerm = (
  code: unknown,
  value: unknown,
): EmailReturnTerm | SaleTerm.Lifetime | undefined => {
  const offer = getEmailOffer(code);
  if (!offer || typeof value !== 'string') return undefined;
  const terms: readonly string[] =
    offer.action === 'switch' ? [SaleTerm.Annual, SaleTerm.Lifetime] : EMAIL_RETURN_TERMS;
  return terms.includes(value) ? (value as EmailReturnTerm | SaleTerm.Lifetime) : undefined;
};
